import { render, staticRenderFns } from "./SetupStep01.vue?vue&type=template&id=47747d0a&scoped=true&"
import script from "./SetupStep01.vue?vue&type=script&lang=js&"
export * from "./SetupStep01.vue?vue&type=script&lang=js&"
import style0 from "./SetupStep01.vue?vue&type=style&index=0&id=47747d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47747d0a",
  null
  
)

export default component.exports